import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const slice = createSlice({
	name: "globals",
	initialState,
	reducers: { update: (state, { payload }) => ({ ...state, ...payload }) },
});

export const globalsSelector = (state) => state?.globals || {};

export const { actions, reducer } = slice;

export default reducer;
